module.exports = {"371772001":"万福街道","371772100":"吕陵镇","371772108":"马岭岗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371772.json
// module id = 1631
// module chunks = 0